<!--机构认证-->
<template>
  <div class="agency-certification-container">
    <div class="agency-certification-content">
      <p class="tips">适用于国家各级政府部门、其他组织等</p>
      <p class="small-title">单位信息</p>
      <el-form ref="agencyForm0" :model="agencyForm" :rules="agencyRules" label-width="100px" style="width: 50%"
               label-position="left">
        <el-form-item label="单位名称：" prop="institutionName">
          <el-input v-model="agencyForm.institutionName"/>
        </el-form-item>
        <el-form :model="agencyForm" :rules="agencyRules" ref="agencyForm1" label-position="top">
          <el-form-item label="组织机构代码证/批复文件：" prop="proofUrl">
            <div class="upload-image">
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         :on-success="successUpload" :show-file-list="false">
                <el-image v-if="agencyForm.proofUrl" :src="agencyForm.proofUrl" fit="cover"
                          style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="修改头像">
            <div class="upload-avatar">
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         :on-success="successUpload2" :show-file-list="false">
                <el-avatar v-if="agencyForm.avatar" :size="100" :src="agencyForm.avatar" fit="cover"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <el-form-item label="所在地区：" prop="address">
          <el-cascader v-model="agencyForm.address" placeholder="" :options="areaInfo"
                       :props="{ expandTrigger: 'hover' }" clearable separator="-"/>
        </el-form-item>
        <el-form :model="agencyForm" :rules="agencyRules" ref="agencyForm2" label-position="top">
          <el-form-item label="上传身份证：" prop="identityimgFront">
            <div style="display: flex;text-align: center;" class="upload-image">
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         style="margin-right: 20px" :on-success="successUpload3" :show-file-list="false">
                <el-image v-if="agencyForm.identityimgFront" :src="agencyForm.identityimgFront" fit="cover"
                          style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__tip" slot="tip">身份证正面</div>
              </el-upload>
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         :on-success="successUpload4" :show-file-list="false">
                <el-image v-if="agencyForm.identityimgBack" :src="agencyForm.identityimgBack" fit="cover"
                          style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__tip" slot="tip">身份证反面</div>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model="agencyForm.phone"/>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="agencyForm.code" maxlength="6" placeholder="">
            <template slot="suffix">
              <el-link style="color: #1637FF;font-size: 14px;" @click="getCode" :underline="false"
                       v-show="flag">获取验证码
              </el-link>
              <el-link disabled v-show="!flag">{{ second + 's后重试' }}</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="开通云官网：">
          <el-switch v-model="agencyForm.chooseMicroWebsite" active-color="#1637FF"
                     :active-value="1" :inactive-value="0" inactive-color="#EEEEEE"/>
        </el-form-item>
        <el-form-item prop="isRead" label-width="0px">
          <el-checkbox v-model="agencyForm.isRead">我已阅读并同意
            <el-link class="el-active" :underline="false" @click="privacyPolicy">《隐私政策》</el-link>
          </el-checkbox>
        </el-form-item>
        <el-form-item label-width="0px">
          <el-button @click="submitForm"
                     :disabled="agencyForm.chooseMicroWebsite==1 && agencyForm.isRead ? false : true"
                     type="danger">提交审核
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {verifyNameIsAuthenticated,reviewAuthenticationForEight} from "@/api/systemSetting";
import areaJson from '@/static/area.json'
import {sendsms} from "@/api/currencyApi";

export default {
  name: "agencyCertification",
  data() {
    const that = this;
    /*验证企业/机构名称是否已被认证*/
    const checkCorporateName = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入单位名称'));
      } else {
        verifyNameIsAuthenticated({name: value, uid: that.userInfo.cid}).then(res => {
          if (res.code == 200) {
            callback();
          } else if (res.code == 202) {
            callback(new Error(res.content));
          }
        })
      }
    }
    /*验证身份证上传*/
    const uploadIdentityCard = (rule, value, callback) => {
      if (that.agencyForm.identityimgFront == '') {
        callback(new Error('请上传身份证正面'));
      } else if (that.agencyForm.identityimgBack == '') {
        callback(new Error('请上传身份证背面'));
      } else {
        callback();
      }
    }
    // 验证手机号
    let validatorPhone = function (rule, value, callback) {
      if (value === "")
        callback(new Error("手机号不能为空"));
      else if (!/^1\d{10}$/.test(value))
        callback(new Error("手机号格式错误"));
      else
        callback();
    }
    return {
      agencyForm: {
        institutionName: '',/*机构/公司名称*/
        avatar: '',/*机构头像*/
        proofUrl: '',/*组织机构代码证/批复文件*/
        address: '',/*所在地区*/
        identityimgFront: '',/*身份证人像面*/
        identityimgBack: '',/*身份证国徽面*/
        phone: '',/*联系电话*/
        code: '',/*验证码*/
        chooseMicroWebsite: 0,/*开通云官网选择状态（0：未选择，1：已选择）*/
        isRead: false,
      },
      agencyRules: {
        institutionName: [
          {required: true, validator: checkCorporateName, trigger: 'blur'}
        ],
        proofUrl: [
          {required: true, message: '请上传组织机构代码证/批复文件', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ],
        identityimgFront: [
          {required: true, validator: uploadIdentityCard, trigger: "change"}
        ],
        phone: [
          {required: true, validator: validatorPhone, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      userInfo: {},
      areaInfo: areaJson,
      flag: true,
      second: 300,
      timer: null, // 该变量是用来记录定时器的,防止点击的时候触发多个setInterval
    }
  },
  methods: {
    /*图片上传成功后处理-修改头像*/
    successUpload2(response, file, fileList) {
      this.agencyForm.avatar = response.imgPath;
    },
    /*图片上传成功后处理-组织机构代码证/批复文件*/
    successUpload(response, file, fileList) {
      this.agencyForm.proofUrl = response.imgPath;
    },
    /*图片上传成功后处理-身份证正面*/
    successUpload3(response, file, fileList) {
      this.agencyForm.identityimgFront = response.imgPath;
    },
    /*图片上传成功后处理-身份证国徽面*/
    successUpload4(response, file, fileList) {
      this.agencyForm.identityimgBack = response.imgPath;
    },
    /*发送手机验证*/
    getCode() {
      let that = this;
      if (this.second < 120) {
        return
      }
      if (that.flag) {
        sendsms({mobile: that.operationForm.phone, name: "申请认证", uid: that.userInfo.cid, uuid: '帮企网'}).then(res => {
          if (res.code == 200) {
            this.$message.success('验证码已发送');
            that.flag = false;
            let interval = setInterval(() => {
              if (that.second <= 0) {
                clearInterval(interval);
                this.second = 120;
                that.flag = true;
                return
              } else {
                this.second--
              }
            }, 1000)
          }
        })
      }
    },
    /*隐私政策*/
    privacyPolicy() {
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA=', '_blank')
    },
    /*提交申请*/
    submitForm() {
      let that = this;
      let can = 0;
      for (let a = 0; a < 3; a++) {
        that.$refs['agencyForm' + a].validate((valid) => {
          if (valid) {
          } else {
            can++;
            return false;
          }
        });
      }
      if (can == 0) {
        console.log(that.agencyForm);
        let address = '';
        for (let city of that.areaInfo) {
          if (city.value == that.agencyForm.address[0]) {
            address = city.label;
            for (let children of city.children) {
              if (children.value == that.agencyForm.address[1]) {
                address += '-' + children.label;
                for (let sub of children.children) {
                  if (sub.value == that.agencyForm.address[2]) {
                    address += '-' + sub.label;
                  }
                }
              }
            }
          }
        }
        let formData = {
          bqwCertificationEightVO: {
            verifiedType: 2,
            institutionName: that.agencyForm.institutionName,
            abbreviation: "",
            socialCreditCode: "",
            avatar: that.agencyForm.avatar,
            summary: "",
            locationCity: address,
            contactAddress: "",
            cityCode: that.agencyForm.address[0],
            areaCode: that.agencyForm.address[1],
            districtCode: that.agencyForm.address[2],
            identityimgBack: that.agencyForm.identityimgBack,
            identityimgFront: that.agencyForm.identityimgFront,
            phone: that.agencyForm.phone,
            code: that.agencyForm.code,
            id: 0,
            microWebsiteStatus: 0,
            certificationProofList: [
              {
                proofType: 6,
                proofUrl: that.agencyForm.proofUrl
              }
            ],
            chooseMicroWebsite: 1,
            cid: that.userInfo.cid
          },
          certificationProofList: [
            {
              proofType: 6,
              proofUrl: that.agencyForm.proofUrl
            }
          ],
          uid: that.userInfo.cid
        }
        reviewAuthenticationForEight(formData).then(res=>{
          if (res.code==200){
            that.$alert('机构认证信息提交成功，正在审核，请耐心等待。', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.location.reload()
              }
            });
          }
        })
      }
    }
  },
  mounted() {

  },
  beforeMount() {
    this.userInfo = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')) : {};
    this.agencyForm.avatar = this.userInfo.user_avatar;
  },
  beforeDestroy() {
    clearInterval(this.second);
    this.second = null;
  },
}
</script>
<style scoped>
.agency-certification-container >>> .agency-certification-content .upload-image .el-upload {
  border: 1px solid #F2F2F2;
  background: #F2F2F2;
  border-radius: 6px;
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 25px;
  color: #666;
}

.agency-certification-container >>> .agency-certification-content .upload-avatar .el-upload {
  border: 1px solid #F2F2F2;
  background: #F2F2F2;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 25px;
  color: #666;
}

.agency-certification-container >>> .agency-certification-content .el-upload__tip {
  font-size: 14px;
  color: #333333;
  margin-top: 0px;
}

.agency-certification-container >>> .agency-certification-content .el-form--label-top .el-form-item__label {
  padding: 0 0 0px;
}

.agency-certification-container >>> .agency-certification-content .el-cascader {
  width: 100%;
}

.agency-certification-container >>> .agency-certification-content .el-checkbox__label {
  display: inline-flex;
  font-size: 14px;
  color: #333333;
}

.agency-certification-container >>> .agency-certification-content .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  width: 30%;
  padding: 15px;
}

.agency-certification-container >>> .agency-certification-content input::-webkit-input-placeholder,
.agency-certification-container >>> .agency-certification-content textarea::-webkit-input-placeholder {
  font-size: 14px;
  color: #ABABAB;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
}

.agency-certification-container >>> .el-form-item__label {
  font-size: 14px;
  color: #333333;
}

.agency-certification-container >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.agency-certification-container >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1637FF;
  border-color: #1637FF;
}
</style>
<style scoped lang="scss">
.agency-certification-container {
  .agency-certification-content {
    .tips {
      margin-block-end: 0px;
      margin-block-start: 0px;
      font-size: 14px;
      color: #666666;
    }

    .small-title {
      margin-block-end: 20px;
      margin-block-start: 20px;
      font-size: 16px;
      font-family: 'SourceHanSansCN';
      color: #333333;
    }

    .el-active {
      color: #1637FF;
    }

    .gary-tips {
      margin-block-start: 0px;
      margin-block-end: 0px;
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>